import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-form-input-readonly',
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, TranslateModule],
  templateUrl: './form-input-readonly.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormInputReadonlyComponent {
  @Input() labelT = '';
  @Input() value = '';
}
